import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import ScrollToHash from "@/components/ScrollToHash";
import "@/App.css";

import HomePage from "@/pages/HomePage";
import AnalysisPage from "@/pages/AnalysisPage";
import HowItWorksPage from "@/pages/HowItWorksPage";
import SignalsPage from "@/pages/SignalsPage";
import DoubtPage from "@/pages/DoubtPage";
import LegalPage from "@/pages/LegalPage";
import PrivacyPage from "@/pages/PrivacyPage";
import ContactPage from "@/pages/ContactPage";
import AboutPage from "@/pages/AboutPage";
import BlogPage from "@/pages/BlogPage";
import BlogArticlePage from "@/pages/BlogArticlePage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import CookieConsent from "@/components/CookieConsent";
import NotFoundPage from "@/pages/NotFoundPage";

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToHash />
          <div className="App">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/analyse/:domain" element={<AnalysisPage />} />
              <Route path="/comment-ca-marche" element={<HowItWorksPage />} />
              <Route path="/signaux" element={<SignalsPage />} />
              <Route path="/en-cas-de-doute" element={<DoubtPage />} />
              <Route path="/mentions-legales" element={<LegalPage />} />
              <Route path="/politique-de-confidentialite" element={<PrivacyPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/a-propos" element={<AboutPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogArticlePage />} />
              <Route path="/admin" element={<AdminLoginPage />} />
              <Route path="/admin/dashboard" element={
                <ProtectedRoute><AdminDashboardPage /></ProtectedRoute>
              } />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
            <CookieConsent />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
